import React, {Component} from 'react';
import {Badge, Card, CardBody, CardHeader, Col, Progress, Row, Table} from 'reactstrap';
import {toast, ToastContainer} from 'react-toastify';
import {getData} from '../../api/doLogin.js';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import './react_dates_overrides.css';
import '../../../scss/vendors/react-select/react-select.scss';
import io from "../../api/socket.io";
import {zPad} from "./shared/shared";

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

class ApplicationSubmit extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);
    this.ProcessApps = this.ProcessApps.bind(this);
    this.socket;
    this.state = {
      data: [],
      dataLoaded: false,
      windowWidth: window.innerWidth,
      orientation: 'vertical',
      status: "Attempting to make connection to processing server...",
      applications: [],
      progress: 0,
      activeIndex: -1
    };
  }


  componentDidMount() {
    console.log(this.props);
    this.updateData();
    window.addEventListener('resize', this.updateDimensions);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.type !== this.props.match.params.type || prevProps.action !== this.props.action || prevProps.match.params.id !== this.props.match.params.id) {
      this.updateData();
    }

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
    if (this.socket) {
      this.socket.destroy();
      this.socket = null;
    }
  }

  updateDimensions() {
    const windowWidth = window.innerWidth;
    this.setState((state) => {
      return ({
        windowWidth: windowWidth,
        orientation: windowWidth < 620 ? 'vertical' : 'horizontal',
        openDirection: windowWidth < 620 ? 'up' : 'down'
      });
    });
  }

  updateData() {
    if (this.props.action === "add") {
      this.setState({dataLoaded: true, formFields: {}});
      return;
    }
    let self = this;
    getData("applications/getsubmitted?id=" + this.props.match.params.id, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          console.log(data.data);
          self.setState({
            data: data.data,
            dataLoaded: true,
            applications: data.data.applications,

          });
          if (data.data.applications.length > 0) {
            this.connectSocketServer();
          }
        }
      })
      .catch(error => {
        console.error(error)
      });
  }

  connectSocketServer() {
    let self = this;
    this.socket = io('https://eapp-server.apps2.smithos.net/');
    // this.socket = io("http://localhost:8080");
    this.socket.on('connect', function () {
      console.log('I am connected to socket');
      self.setState({status: "Connected to Processing Server. Starting..."});
      setTimeout(() => {
        self.ProcessApps();
      }, 1000);
    });
    this.socket.on('status', function (data) {
      console.log("Response:", data);

      // $("#terminal").text(data.msg + " (" + Math.round(data.progress * 100) + "%)");
      if (data.status === "Error") {
        const tApps = self.state.applications;
        tApps[self.state.activeIndex].status = "error";
        console.log(self.state.activeIndex);
        self.setState({progress: 0, applications: tApps, status: data.msg}, () => {
          setTimeout(() => {
            self.ProcessApps();
          }, 1000);
        });
        console.log(tApps);
      } else if (data.status === "Success") {
        const tApps = self.state.applications;
        tApps[self.state.activeIndex].status = "complete";
        console.log(self.state.activeIndex);
        self.setState({activeIndex: -1, applications: tApps, status: data.msg}, () => {
          self.setState({progress: 0}, () => {
            setTimeout(() => {
              self.ProcessApps();
            }, 1000);
          });
        });
        console.log(tApps);
      } else if (data.status === "Queued") {
        self.setState({status: data.msg});
      } else if (data.status === "Starting") {
        self.setState({status: data.msg});
      } else if (data.status === "Processing") {
        self.setState({status: data.msg});
        setTimeout(() => {
          self.ProcessApps();
        },30000);
      } else {
        self.setState({progress: Math.round(data.progress * 100), status: data.msg});
      }

    });
    this.socket.on('disconnect', function () {
      console.log("Disconnected");
      self.setState({status: "Processing Server Disconnected.", activeIndex: -1});
      // $("#btnSubmit").attr('disabled', 'disabled');
    });
  }

  ProcessApps(context) {
    let self = this;
    if (self.state.applications.filter(r => r.status === "queued" || r.status === "working").length > 0) {
      console.log("have apps to process");
      for (let a = 0; a < self.state.applications.length; a++) {
        if (self.state.applications[a].status === "queued" || self.state.applications[a].status === "working") {
          console.log(a);
          self.setState({progress: 0, activeIndex: a}, () => {
            //send app
            //ingect Travis data:
            const today = new Date();
            const filledDate = "" + zPad(today.getUTCMonth().toString(),2) + "/" + zPad(today.getUTCDate().toString(),2) + "/" + today.getUTCFullYear();
            self.state.applications[a].data['agent']['date'] = filledDate;
            self.state.applications[a]['test'] = false;
            self.state.applications[a]['fullScreen'] = true;
            self.socket.emit('submit_app', self.state.applications[a]);
            // console.log(self.state.applications[a]);
          });
          break;
        }
      }

    } else {
      console.log("No more to do");
      self.socket.close();
    }
  }

  onCloseClick() {
    this.props.history.push("/applications");
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  downloadFile(evt, appid, id, key) {
    evt.preventDefault();
    getData('applications/downloadFile/' + appid + "/" + id, {}, this.props.token)
      .then((data) => {
        if (data.status == "Success") {
          console.log(data.data);
          if (typeof window !== 'undefined') {
            window.location.href = data.data.url;
          } else {
            toast.error("Browser Configuration error. Try a different browser");
          }
        } else {
          toast.error(data.message);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  visibleFiles(data, ind) {
    if (data.hasOwnProperty("files")) {
      if (data.files.length > 0) {
        return data.files.map((file, index) => {
          return (
            <div key={index}>
              <a style={{cursor: 'pointer'}}
                 onClick={(e) => this.downloadFile(e, data.appid, file.id, file.key)}>{file.fileName}</a>
            </div>
          );
        });
      } else {
        return <a style={{cursor: 'pointer'}}
                  onClick={(e) => this.retrieveFiles(e, data.appid, data.id, ind, true)}>No Applications found. Show
          Images?</a>
      }
    }
    return null;
  }

  getStatus(data, index) {
    if (index === this.state.activeIndex) {
      return (
        <Progress animated color="info" value={this.state.progress} className="mb-3"/>
      )
    } else {
      switch (data.status) {
        case "complete":
          return (
            <div>
              <Badge color="success">Complete</Badge>&nbsp;&nbsp;
              {data.hasOwnProperty("files") ?
                <div>{this.visibleFiles(data, index)}</div>
                :
                <a style={{cursor: 'pointer'}}
                   onClick={(e) => this.retrieveFiles(e, data.appid, data.id, index, false)}>See Files</a>
              }
            </div>);
          break;
        case "error":
          return (<div><Badge color="danger">Error</Badge>&nbsp;&nbsp;<span>{data.processorLog}</span>&nbsp;&nbsp;
            {data.hasOwnProperty("files") ?
              <div>{this.visibleFiles(data, index)}</div>
              :
              <a style={{cursor: 'pointer'}} onClick={(e) => this.retrieveFiles(e, data.appid, data.id, index, true)}>See
                Files</a>
            }
          </div>);
          break;
        case "waiting":
          return (<Badge color="secondary">Inactive</Badge>);
          break;
        default:
          return (<Badge color="warning">Pending</Badge>);
          break;
      }
    }
  }

  retrieveFiles(evt, uuid, appid, index, all) {
    evt.preventDefault();
    let self = this;
    getData("applications/getappfiles?appid=" + this.props.match.params.id + "&id=" + appid, {seeAll: all}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          const applications = this.state.applications;
          applications[index]['files'] = data.data.files;
          self.setState({applications});
        }
      })
      .catch(error => {
        console.error(error)
      });
  }

  render() {
    const containerStyle = {
      zIndex: 1999
    };

    return (
      <div className="animated fadeIn">
        <ToastContainer position="bottom-right" autoClose={5000} style={containerStyle}/>
        {this.state.dataLoaded && (
          <Card>
            <CardHeader>
              Application Submission
              <div className="card-actions">
                <button onClick={() => this.onCloseClick()}>
                  <small className="text-muted">Close</small>
                </button>
              </div>
            </CardHeader>
            <CardBody>
              <Row>
                <Col xs={12}>
                  <div align="center">Do not navigate away from this page while server is processing.</div>
                  <Table hover bordered striped responsive size="sm">
                    <thead>
                    <tr>
                      <th width="25%">Display</th>
                      <th width="25%">Type</th>
                      <th width="50%">Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.applications && this.state.applications.map((data, index) => {

                      return (<tr key={index}>
                        <td>{data.display}</td>
                        <td>{data.type}</td>
                        <td>
                          {this.getStatus(data, index)}
                        </td>
                      </tr>)
                    })}
                    </tbody>
                  </Table>
                  {this.state.status}
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}
      </div>
    )
  }
}

export default ApplicationSubmit;



// WEBPACK FOOTER //
// ./src/containers/Applications/ApplicationSubmit.js